import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    minHeight: "100%",
    alignItems: "center",
    backgroundColor: "#EDF2F7",
    padding: theme.spacing(2),
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    width: "100%",
    minHeight: "700px",
    padding: theme.spacing(4),
    gap: "8px",
    margin: 0,
    boxShadow: "none",
    borderRadius: 0,
    backgroundColor: "#FFF",
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px",
    },
  },
  logoWrapper:{
    "& img":{
      width:'180px',
      [theme.breakpoints.down("md")]: {
        width: "180px", 
      },
  
      [theme.breakpoints.down("sm")]: {
        width: "120px", 
      },
  
      [theme.breakpoints.down("xs")]: {
        width: "100px", 
      },

    }
  },
  listItem: {
    padding: theme.spacing(1.5, 0),
    "& h3": {
      cursor:"pointer",
      marginBottom:"20px"
    },
  },


  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(4),
  },
  logo: {
    width: 48,
    height: 48,
  },
  settingsList: {
    padding: 0,
  },


  backIcon: {
    width: 32,
    height: 32,
    cursor: "pointer",
  },




  communityHeading: {
    paddingTop: 0,
    fontFamily: "MontserratRegular",
    fontWeight: 700,
    fontSize: "25px",
    Lineheight: "23.03px",
    color: "#2158D0",
    display:'flex',
    justifyContent:'center'

  },


  pagetitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItem: 'center',
    "& h5": {
      fontSize: '30px',
      fontWeight: 700,
      color: "#2158D0",
      fontFamily: 'MontserratRegular'

    },
  },
  mainTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(3),
  },
  settingList: {
    fontWeight: 400,
    cursor: 'poiner'
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: "40px",
    color: "#000000",
    fontStyle: "bold",
    fontFamily: "MontserratRegular",
    lineHeight: "23.03px",
    cursor: "pointer"
  },
//  notification Setting

switchBtn: {
  color: "#5C91FF",
  "& .Mui-checked .MuiSwitch-thumb": {
    backgroundColor: "#5C91FF",
  },
},
sectionSubtitle: {
  color: "#718096",
  fontSize: "0.9rem",
},
notificationItem: {
  padding: theme.spacing(1.5, 0),
  "& .MuiTypography-body1": {
    color: "#000000",
    fontSize: "14px",
    fontWeight: 400,
    fontfamily: "MontserratRegular",
    lineHeight: "1.5",
  },
},
radioGroup: {
  marginLeft: theme.spacing(1),
},
radioRoot: {
  "& .MuiSvgIcon-root": {
    color: "#5C91FF",
  },
  "&.Mui-checked .MuiSvgIcon-root": {
    color: "#5C91FF",
  },
},
radioLabel: {
  marginBottom: theme.spacing(1),
  "& .MuiTypography-body1": {
    color: "black",
    fontSize: "14px",
    fontWeight: 400,
    fontfamily: "MontserratRegular",
    lineHeight: "1.5",
  },
},
buttonContainer: {
  marginTop: theme.spacing(4),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
},
unsubscribeButton: {
  color: "#E53E3E",
  fontWeight: 800,
  display: "flex",
  alignItems: "center",
  marginTop: "20px",
  justifyContent: "flex-start",
},

buttonContent: {
  display: "flex",
  alignItems: "start",
  gap: "12px",
  textTransform: "capitalize",
},
saveButton: {
  padding: theme.spacing(1.5),
  fontWeight: 700,
  textTransform: "none",
  borderRadius: 8,
  backgroundColor: "#5C91FF",
  color: "white",
},
}));
